import { Link } from 'react-location';
import Card from '../Card';

import './CarouselMobile.scss';

const CarouselMobile = ({ cards }) => {
  return (
    <div className="carousel-mobile">

      <div className="carousel-mobile__cards--wrapper">
        {cards.map((card) => (
          <div className="carousel-mobile__card--wrapper" key={card.name}>
            <div className="carousel--card__title--wrapper">
              <h4 className="carousel--card__title">{card.name}</h4>

              <Link className="discover--link" to={card.url}>
                Découvrir
                <img alt="flèche icon" className="icon__arrow" src="/images/Home/arrow.svg" />
              </Link>
            </div>

            <Card
              cardInfo={card}
              isFocus={true}
              isNext={false}
              isTransitionEnabled={false}
              key={card.name}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default CarouselMobile;
